const map = {
	"./Calendar.ejs": 6621,
	"./Dossier.ejs": 7570,
	"./Double.ejs": 9036,
	"./List.ejs": 8999,
	"./Simple.ejs": 3197,
	"./TaskMenu.ejs": 8809,
	"./TaskMenuEntry.ejs": 4511,
	"./View.ejs": 1828
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3832;